import { PortalError } from './PortalError';

export class NoContextError extends PortalError {
  constructor(displayName: string = '') {
    super('NoContextError', `use${displayName}Context must be used inside the ${displayName}Provider`);
  }
}
